export default function CommonTasksSection() {
  const taskGroups = [
    {
      trigger: 'Компания быстро растёт',
      solution: 'Нужно системное обучение — чтобы масштабирование не превратилось в хаос',
      icon: 'ri-rocket-line',
      link: { label: 'Программы развития для растущих компаний', href: '/' }
    },
    {
      trigger: 'Большая текучесть кадров',
      solution: 'Нужно обучение — люди уходят туда, где есть развитие и карьерный рост',
      icon: 'ri-user-unfollow-line',
      link: { label: 'Как обучение снижает текучесть', href: '/enciklopediya-korporativnogo-obucheniya/obuchenie-personala' }
    },
    {
      trigger: 'Падает конверсия продаж',
      solution: 'Нужно обучение отдела продаж — диагностика, навыки, практика',
      icon: 'ri-arrow-down-line',
      link: { label: 'Тренинги по продажам', href: '/enciklopediya-korporativnogo-obucheniya/obuchenie-otdela-prodazh' }
    },
    {
      trigger: 'Много новичков в команде',
      solution: 'Нужна система адаптации и обучение — чтобы новички быстрее выходили на результат',
      icon: 'ri-user-add-line',
      link: { label: 'Программы адаптации сотрудников', href: '/enciklopediya-korporativnogo-obucheniya/adaptaciya-sotrudnikov' }
    },
    {
      trigger: 'Конфликты между отделами',
      solution: 'Нужны коммуникативные тренинги — продажи и производство, маркетинг и логистика',
      icon: 'ri-shake-hands-line',
      link: { label: 'Командообразование и коммуникация', href: '/enciklopediya-korporativnogo-obucheniya/komandoobrazovanie' }
    },
    {
      trigger: 'Новые руководители не справляются',
      solution: 'Нужно обучение управленческим навыкам — делегирование, мотивация, контроль',
      icon: 'ri-user-star-line',
      link: { label: 'Обучение руководителей', href: '/enciklopediya-korporativnogo-obucheniya/trening-dlya-rukovoditeley' }
    },
    {
      trigger: 'Сотрудники работают на автомате',
      solution: 'Нужно обучение для вовлечения — интерес возвращает мотивацию и инициативу',
      icon: 'ri-emotion-line',
      link: { label: 'Повышение вовлечённости команды', href: '/enciklopediya-korporativnogo-obucheniya/razvitie-soft-skills' }
    },
    {
      trigger: 'Рынок изменился — команда отстаёт',
      solution: 'Нужна адаптация компетенций — новые инструменты, методики, подходы',
      icon: 'ri-refresh-line',
      link: { label: 'Адаптация команды к изменениям', href: '/enciklopediya-korporativnogo-obucheniya/chto-takoe-korporativnoe-obuchenie' }
    },
  ];

  return (
    <section id="tasks" className="py-20 md:py-28 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <h2 className="text-3xl md:text-5xl font-bold text-gray-900 text-center mb-4">
          Частые задачи компаний
        </h2>
        <p className="text-lg text-gray-600 text-center mb-14 max-w-3xl mx-auto">
          Если вы узнаёте свою ситуацию — значит, пора инвестировать в обучение сотрудников
        </p>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {taskGroups.map((task, i) => (
            <div key={i} className="bg-white rounded-xl p-6 hover:shadow-md transition-shadow flex flex-col">
              <div className="w-10 h-10 bg-red-50 rounded-lg flex items-center justify-center mb-3">
                <i className={`${task.icon} text-lg text-red-500`}></i>
              </div>
              <div className="mb-2">
                <span className="inline-block bg-red-100 text-red-700 text-xs font-semibold px-2.5 py-1 rounded-full">
                  Проблема
                </span>
              </div>
              <h3 className="text-base font-bold text-gray-900 mb-2">{task.trigger}</h3>
              <div className="w-8 flex justify-center my-2">
                <i className="ri-arrow-down-line text-teal-500 text-lg"></i>
              </div>
              <p className="text-sm text-gray-600 mb-4 flex-1">{task.solution}</p>
              <a
                href={task.link.href}
                className="inline-flex items-center text-teal-600 text-sm font-semibold hover:text-teal-700 transition-colors mt-auto whitespace-nowrap cursor-pointer"
              >
                {task.link.label} <i className="ri-arrow-right-line ml-1"></i>
              </a>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}